import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { unsafeHTML as o } from '../../node_modules/lit-html/directives/unsafe-html.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';

var HeadingLevel;
(function (HeadingLevel) {
    HeadingLevel["one"] = "1";
    HeadingLevel["two"] = "2";
    HeadingLevel["three"] = "3";
    HeadingLevel["four"] = "4";
    HeadingLevel["five"] = "5";
    HeadingLevel["six"] = "6";
})(HeadingLevel || (HeadingLevel = {}));
/**
 * Note that when using the Helios/FMR Standards overrides, the light gray background has no effect
 */
var FootnotesBackground;
(function (FootnotesBackground) {
    FootnotesBackground["white"] = "white";
    FootnotesBackground["light-gray"] = "light-gray";
})(FootnotesBackground || (FootnotesBackground = {}));
var AnnotationSymbol;
(function (AnnotationSymbol) {
    AnnotationSymbol["dagger"] = "&dagger;";
    AnnotationSymbol["double dagger"] = "&Dagger;";
    AnnotationSymbol["section"] = "&sect;";
    AnnotationSymbol["parallels"] = "&raquo;";
    AnnotationSymbol["number"] = "&#35;";
})(AnnotationSymbol || (AnnotationSymbol = {}));
const DEFAULT_BACKGROUND = FootnotesBackground.white;
const DEFAULT_HEADING_LEVEL = HeadingLevel.three;
/**
 * Providence Footnotes component.
 * @see {@link https://providence.fmr.com/4.x/components/footnotes/footnotes.html|Footnotes & Disclosures documentation}
 */
class PvdFootnotes extends PvdSlotifyBaseComponent {
    constructor() {
        super(...arguments);
        //#endregion
        // #region LitElement properties
        this.pvdBackground = DEFAULT_BACKGROUND;
        // #endregion
    }
    // #endregion
    // #region LitElement lifecycles
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-footnotes-root`,
            modifierPrefix: 'pvd-footnotes',
            modifiers: [
                {
                    condition: this.pvdBackground !== undefined,
                    className: `background-${this.pvdBackground}`,
                },
            ],
        };
        return x `<div class="${getClassName(classMap)}" role="complementary" aria-label="Footnotes"><s-slot></s-slot></div>`;
    }
}
//#region Component configuration
PvdFootnotes.componentName = 'footnotes';
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-background',
        ...PvdSlotifyBaseComponent.hasChanged(FootnotesBackground),
    }),
    __metadata("design:type", Object)
], PvdFootnotes.prototype, "pvdBackground", void 0);
/**
 * Providence Footnote component.
 * @see {@link https://providence.fmr.com/4.x/components/footnotes/footnotes.html|Footnotes & Disclosures documentation}
 */
class PvdFootnote extends PvdSlotifyBaseComponent {
    constructor() {
        super(...arguments);
        //#endregion
        // #region LitElement properties
        this.pvdHeadingLevel = DEFAULT_HEADING_LEVEL;
        //#endregion
    }
    // #endregion
    // #region LitElement lifecycles
    renderTitle() {
        switch (this.pvdHeadingLevel) {
            case HeadingLevel.one:
                return x `<h1 class="pvd-footnote__title">${this.pvdTitle}</h1>`;
            case HeadingLevel.two:
                return x `<h2 class="pvd-footnote__title">${this.pvdTitle}</h2>`;
            case HeadingLevel.three:
                return x `<h3 class="pvd-footnote__title">${this.pvdTitle}</h3>`;
            case HeadingLevel.four:
                return x `<h4 class="pvd-footnote__title">${this.pvdTitle}</h4>`;
            case HeadingLevel.five:
                return x `<h5 class="pvd-footnote__title">${this.pvdTitle}</h5>`;
            case HeadingLevel.six:
                return x `<h6 class="pvd-footnote__title">${this.pvdTitle}</h6>`;
        }
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-footnote-root`,
            modifierPrefix: 'pvd-footnote',
            modifiers: [],
        };
        return x `<div class="${getClassName(classMap)}">${this.pvdTitle ? x `${this.renderTitle()}` : ''}<div class="pvd-footnote__text"><s-slot>${this.pvdText}</s-slot></div></div>`;
    }
}
//#region Component configuration
PvdFootnote.componentName = 'footnote';
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-heading-level',
        ...PvdSlotifyBaseComponent.hasChanged(HeadingLevel),
    }),
    __metadata("design:type", String)
], PvdFootnote.prototype, "pvdHeadingLevel", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-text' }),
    __metadata("design:type", String)
], PvdFootnote.prototype, "pvdText", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-title' }),
    __metadata("design:type", String)
], PvdFootnote.prototype, "pvdTitle", void 0);
/**
 * Providence Footnote Annotation component.
 * @see {@link https://providence.fmr.com/4.x/components/footnotes/footnotes.html|Footnotes & Disclosures documentation}
 */
class PvdFootnoteAnnotation extends PvdSlotifyBaseComponent {
    constructor() {
        super(...arguments);
        this.pvdSymbolRepeat = 1;
        // #endregion
    }
    // #endregion
    // #region LitElement lifecycles
    renderBackLink() {
        return this.pvdBackHref
            ? x `<a href="${this.pvdBackHref}" class="pvd-footnote-annotation__back-link"><span class="pvd-footnote-annotation__back-link-text">Back to content</span>^</a>`
            : '';
    }
    renderSymbol() {
        let symbol = this.pvdSymbol;
        if (AnnotationSymbol[this.pvdSymbol]) {
            symbol = AnnotationSymbol[this.pvdSymbol];
        }
        let repeatedSymbol = symbol;
        for (let i = 1; i < this.pvdSymbolRepeat; i++) {
            repeatedSymbol += symbol;
        }
        return repeatedSymbol;
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-footnote-annotation-root`,
            modifierPrefix: 'pvd-footnote-annotation',
            modifiers: [],
        };
        return x `<div class="${getClassName(classMap)}" tabindex="-1"><div class="pvd-footnote-annotation__symbol">${o(this.renderSymbol())}</div><div class="pvd-footnote-annotation__text"><s-slot>${this.pvdText}</s-slot>${this.renderBackLink()}</div></div>`;
    }
}
//#region Component configuration
PvdFootnoteAnnotation.componentName = 'footnote-annotation';
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-back-href' }),
    __metadata("design:type", String)
], PvdFootnoteAnnotation.prototype, "pvdBackHref", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-symbol' }),
    __metadata("design:type", String)
], PvdFootnoteAnnotation.prototype, "pvdSymbol", void 0);
__decorate([
    n({ type: Number, reflect: true, attribute: 'pvd-symbol-repeat' }),
    __metadata("design:type", Number)
], PvdFootnoteAnnotation.prototype, "pvdSymbolRepeat", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-text' }),
    __metadata("design:type", String)
], PvdFootnoteAnnotation.prototype, "pvdText", void 0);

export { AnnotationSymbol, DEFAULT_BACKGROUND, DEFAULT_HEADING_LEVEL, FootnotesBackground, HeadingLevel, PvdFootnote, PvdFootnoteAnnotation, PvdFootnotes };
//# sourceMappingURL=pvd-footnotes.js.map
